import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { IoClose, IoCloudUploadOutline } from 'react-icons/io5'
import Pdf from '../Assets/Images/Employee/Pdf.svg'
import closeIcon from '../Assets/Images/Pop-Up/Close_button.svg'

import Select from 'react-select';
import { customStyle } from './Style';

const DocumentTypes = [
    { value: 'Aadhar Card', label: 'Aadhar Card' },
    { value: 'PAN Card', label: 'PAN Card' },
    { value: 'Driving Licence', label: 'Driving Licence' },
    { value: 'Passbook', label: 'Passbook' },
    { value: 'Photograph', label: 'Photograph' },
];

function AddDocumentModal({ showModal, onClose, handleRemoveFile, handleFileChange, previews, handleAdd, fileType, setFileType, files }) {

    return (
        <Modal show={showModal} onHide={onClose} size="lg" aria-labelledby="contained-modal-title-vcenter"
            centered className="custom-modal">
            <div className="modal-content">
                <div className="modal-header">
                    <h5>Add Document</h5>
                    <button className="close-btn" onClick={onClose}>{<img src={closeIcon} alt="Close" />}</button>
                </div>
                <div className="modal-body">
                    <div className='add-document-container'>
                        <div className='add-information-part'>
                            <div className='form-part'>
                                <form action="">
                                    <div className="form-group">
                                        {/* <label htmlFor="fileName" className='form-label'>File name</label>
                                        <input type="text" className="form-control" id="fileName" value={fileName} onChange={(e) => setFileName(e.target.value)} /> */}

                                        <div className="col-lg-12">
                                            <div className="input-group">
                                                <h6 className='label'>Select Document <span style={{ color: 'red' }}>*</span></h6>
                                                <Select
                                                    options={DocumentTypes}
                                                    styles={{
                                                        ...customStyle,
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 2,
                                                        }),
                                                    }}
                                                    value={fileType?.val}
                                                    placeholder="---"
                                                    onChange={(val) => {
                                                        setFileType((preVal) => ({
                                                            ...preVal,
                                                            val
                                                        }));
                                                    }}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#5757fe",
                                                            primary: "#5757fe",
                                                        },
                                                    })}
                                                />
                                            </div>
                                        </div>
                                        <div className="input-group">
                                            <label className="form-label">Upload files <span style={{ color: 'red', fontSize: '0.9em', marginLeft: '8px' }}>*</span></label>
                                            <div className="file-upload-wrapper">
                                                <label htmlFor="file-upload" className="file-upload-label">
                                                    <IoCloudUploadOutline />
                                                    <p>Choose files</p>
                                                </label>
                                                <input
                                                    type="file"
                                                    id="file-upload"
                                                    className="file-upload-input"
                                                    name="photos"
                                                    multiple
                                                    onChange={handleFileChange}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {previews.length > 0 && (
                                        <div className="preview">
                                            {previews.map((preview, index) => (
                                                <div key={index} className="preview-item">
                                                    {files[index].type.startsWith('application/pdf') ? (
                                                        <div className='preview-pdf'>

                                                            <img src={Pdf} alt="" style={{ width: "100px", height: "100px" }} />
                                                            <div className="remove-pdf-icon" onClick={() => handleRemoveFile(index)}>
                                                                <IoClose />
                                                            </div>
                                                            <div className='preview-text mt-2'>
                                                                <span className='text-center '>
                                                                    {files[index].name}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="preview-image-wrapper">
                                                            <img src={preview} alt={`File preview ${index}`} className="preview-image" />
                                                            <div className="remove-icon" onClick={() => handleRemoveFile(index)}>
                                                                <IoClose />
                                                            </div>
                                                            <div className='preview-text mt-2'>
                                                                <span className='text-center '>
                                                                    {files[index].name}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    )}

                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button className="save-btn" onClick={onClose}>
                        Close
                    </button>
                    <button className="save-btn" onClick={handleAdd}>
                        Save
                    </button>
                </div>
            </div>
        </Modal>
    )
}

export default AddDocumentModal